export const setCustomClasses = (sharedPassageContainer) => {
  const lrnClearfixElement =
    sharedPassageContainer.querySelector('div.lrn_clearfix');

  lrnClearfixElement && lrnClearfixElement.classList.add('grow');

  sharedPassageContainer.classList.add('custom_sharedpassage');
};
